export default __webpack_public_path__ + "static/logo-2276fd8177b49e566eff89ff013fe9b4.svg";